var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import Cookies from 'js-cookie';
import { getPathSegment, segmentToCookieMap, cookieToSegmentMap } from '../../utils';
export const setSegmentCookie = (segment) => {
    const segmentFromCookie = Cookies.get('segment');
    if (!!segment && (!segmentFromCookie || segmentFromCookie !== segmentToCookieMap(segment))) {
        Cookies.set('segment', segmentToCookieMap(segment), { domain: '.telia.ee', expires: 365 });
    }
};
export default class LocationStore {
    constructor(rootStore, props) {
        Object.defineProperty(this, "currentPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "segment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "event", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setLocation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.rootStore.externalCallbackStore.onPathChange(event);
                const { pathname, search, hash } = event.currentTarget;
                const { propStateStore: { isEmbedded }, } = this.rootStore;
                const currentPath = pathname + search + hash;
                this.currentPath = currentPath;
                this.event = event;
                if (!isEmbedded) {
                    this.setSegment(currentPath);
                }
            }
        });
        Object.defineProperty(this, "setSegment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path, customerType) => {
                var _a;
                const { ssoStore, environmentStore: { app }, } = this.rootStore;
                const pathSegment = getPathSegment(path, customerType || ((_a = ssoStore === null || ssoStore === void 0 ? void 0 : ssoStore.authData) === null || _a === void 0 ? void 0 : _a.customerType), app);
                this.setSegmentFromPathOrCookie(pathSegment, cookieToSegmentMap(Cookies.get('segment')));
            }
        });
        Object.defineProperty(this, "setSegmentFromPathOrCookie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (pathSegment, cookieSegment) => {
                const { environmentStore: { app }, } = this.rootStore;
                if (app === 'public') {
                    this.segment = pathSegment;
                }
                else {
                    this.segment = pathSegment || cookieSegment;
                }
            }
        });
        Object.defineProperty(this, "mergeState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path, segmentType) => {
                if (this.currentPath !== path) {
                    this.currentPath = path;
                    this.rootStore.sectionStore.setSection(null);
                }
                const { ssoStore: { authData }, environmentStore: { app }, } = this.rootStore;
                this.segment = getPathSegment(path, segmentType || authData.customerType, app);
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        const { currentPath, customerType } = props;
        this.currentPath = currentPath;
        this.setSegment(currentPath, customerType);
        setSegmentCookie(this.segment);
    }
}
__decorate([
    observable
], LocationStore.prototype, "currentPath", void 0);
__decorate([
    observable
], LocationStore.prototype, "segment", void 0);
__decorate([
    observable
], LocationStore.prototype, "event", void 0);
__decorate([
    action
], LocationStore.prototype, "setLocation", void 0);
__decorate([
    action
], LocationStore.prototype, "setSegment", void 0);
__decorate([
    action
], LocationStore.prototype, "setSegmentFromPathOrCookie", void 0);
__decorate([
    action
], LocationStore.prototype, "mergeState", void 0);
//# sourceMappingURL=LocationStore.js.map